import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import MuiButton from '@material-ui/core/Button'

const useButtonStyles = makeStyles({
  root: {
    textTransform: 'unset',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 8,
    marginBottom: 8,
    fontWeight: 'bold',
    paddingTop: 8,
    paddingBottom: 8
  }
})

const DummySpacerIcon = _props => <span style={{ width: 24 }} />

const Button = ({ buttonColor, textColor = 'white', icon, style, ...props }) => {
  const iconOrSpacer = icon || <DummySpacerIcon />
  return (
    <MuiButton
      classes={useButtonStyles()}
      style={{
        backgroundColor: buttonColor,
        color: textColor,
        ...style
      }}
      fullWidth
      startIcon={iconOrSpacer}
      endIcon={<DummySpacerIcon />}
      {...props}
    />
  )
}

export default Button
